const ClubTypesEnum = {
    STANDARD_DOMESTIC: 'StandardDomestic',
    STANDARD_FOREIGN: "StandardForeign",
    UCI_DOMESTIC: 'UCIDomestic',
    UCI_FOREIGN: "UCIForeign"
}
export default ClubTypesEnum;
